var _defs, _rect, _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategories(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 650",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .card-bg { fill: #ffffff; stroke: #eeeeee; stroke-width: 2; rx: 15; ry: 15; }\n      .label-text { font-family: 'Segoe UI', Arial, sans-serif; font-size: 22px; font-weight: 700; fill: #444; text-anchor: middle; }\n      .icon-stroke { stroke: #333; stroke-width: 2.5; stroke-linecap: round; stroke-linejoin: round; fill: none; }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 650,
    fill: "#f8f9fa"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    className: "card-bg"
  }), /*#__PURE__*/React.createElement("text", {
    x: 125,
    y: 225,
    className: "label-text"
  }, "JUICE"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85, 50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 110 L25 20 H55 L65 110",
    fill: "#FFD93D",
    stroke: "#333",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 20 L28 10 H52 L55 20",
    className: "icon-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 10,
    x2: 60,
    y2: -10,
    className: "icon-stroke",
    stroke: "#FF8008"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 60,
    r: 15,
    fill: "#FFF",
    opacity: 0.3
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(325, 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    className: "card-bg"
  }), /*#__PURE__*/React.createElement("text", {
    x: 125,
    y: 225,
    className: "label-text"
  }, "VEGETABLE"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80, 60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40 C20 10 70 10 70 40 C70 80 45 100 45 100 C45 100 20 80 20 40",
    fill: "#FF6B6B",
    stroke: "#333",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 15 L45 0 M35 10 L45 15 L55 10",
    className: "icon-stroke",
    stroke: "#2D6A4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 30 Q100 10 110 30 Q120 50 100 70 Q80 50 90 30",
    fill: "#6A994E",
    stroke: "#333",
    strokeWidth: 2.5
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(600, 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    className: "card-bg"
  }), /*#__PURE__*/React.createElement("text", {
    x: 125,
    y: 225,
    className: "label-text"
  }, "MEALS"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75, 60)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 45,
    fill: "#f0f0f0",
    stroke: "#333",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 25,
    fill: "#E9C46A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 10 L110 90 M110 10 L115 90",
    className: "icon-stroke",
    stroke: "#8D6E63"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 350)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    className: "card-bg"
  }), /*#__PURE__*/React.createElement("text", {
    x: 125,
    y: 225,
    className: "label-text"
  }, "NON-VEG"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60, 60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20 Q40 -10 80 20 Q40 50 0 20 Z",
    fill: "#A8DADC",
    stroke: "#333",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 20 L100 5 L100 35 L80 20",
    fill: "#457B9D",
    stroke: "#333",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 2,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 30 C10 30 0 50 10 70 C20 85 60 75 80 55 L100 35",
    fill: "none",
    stroke: "#333",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 55 C110 30 90 0 60 10 C40 20 50 50 80 55",
    fill: "#E76F51",
    stroke: "#333",
    strokeWidth: 2.5
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(325, 350)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    className: "card-bg"
  }), /*#__PURE__*/React.createElement("text", {
    x: 125,
    y: 225,
    className: "label-text"
  }, "HOT SOUP"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85, 70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 -10 Q25 -20 20 -30",
    className: "icon-stroke",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 -15 Q45 -25 40 -35",
    className: "icon-stroke",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 -10 Q65 -20 60 -30",
    className: "icon-stroke",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 H80 L70 70 Q40 85 10 70 Z",
    fill: "#F4A261",
    stroke: "#333",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 15 C100 15 100 45 80 45",
    className: "icon-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10 Q40 20 75 10",
    className: "icon-stroke",
    opacity: 0.3
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(600, 350)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    className: "card-bg"
  }), /*#__PURE__*/React.createElement("text", {
    x: 125,
    y: 225,
    className: "label-text"
  }, "SWEETS"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90, 50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 60 Q35 75 70 60 L60 110 H10 L0 60",
    fill: "#f0f0f0",
    stroke: "#333",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 60 C5 20 65 20 65 60",
    fill: "#FFB4C2",
    stroke: "#333",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 25,
    r: 8,
    fill: "#E63946",
    stroke: "#333",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 40 L75 10",
    className: "icon-stroke",
    stroke: "#999"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/categories.3b05accdd42ec921fd99dd6be193b37b.svg";
export { ForwardRef as ReactComponent };